import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
import { CONTACT_INFO } from '../constants';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleCorporateTravelClick = () => {
    setMenuOpen(false);
    // Scroll to top when navigating to corporate travel
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const isHomePage = location.pathname === '/';

  return (
    <>
      {/* Top Bar */}
      <div className="top-bar">
        <div className="container">
          <div className="top-bar-content">
            <div className="top-bar-stats">
              <span className="rajasthan-quote"><i className="fas fa-heart"></i> "Padharo Mhare Desh" - Welcome to Our Land</span>
            </div>
            <div className="top-bar-contact">
              <a href={`tel:${CONTACT_INFO.PHONE.replace(/\s/g, '')}`} className="call-link">
                <span><i className="fas fa-phone"></i> Call Us: {CONTACT_INFO.PHONE}</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Header */}
      <header>
        <div className="container">
          <nav className="navbar">
            <div className="logo">
              <img src="/logo.png" alt={CONTACT_INFO.COMPANY_NAME} className="logo-image" />
              <div className="company-info">
                <span className="company-name">{CONTACT_INFO.COMPANY_NAME}</span>
                <span className="company-since">Since 1992</span>
              </div>
            </div>
            <button 
              className={`menu-toggle ${menuOpen ? 'active' : ''}`}
              onClick={toggleMenu}
              aria-label="Toggle menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
            <ul className={`nav-menu ${menuOpen ? 'active' : ''}`}>
              <li><Link to="/" className={isHomePage ? 'active' : ''} onClick={() => setMenuOpen(false)}>Home</Link></li>
              {isHomePage && (
                <>
                  <li><a href="#rajasthan-tours" onClick={() => setMenuOpen(false)}>Travel Packages</a></li>
                  <li><a href="#destinations" onClick={() => setMenuOpen(false)}>Destinations</a></li>
                  <li><a href="#experiences" onClick={() => setMenuOpen(false)}>Experiences in Rajasthan</a></li>
                  <li><a href="#blog-section" onClick={() => setMenuOpen(false)}>Unravel the Mysteries</a></li>
                  <li><a href="#cab-rental" onClick={() => setMenuOpen(false)}>Cab Rental</a></li>
                </>
              )}
              <li><Link to="/corporate-travel" className={location.pathname === '/corporate-travel' ? 'active' : ''} onClick={handleCorporateTravelClick}>Corporate Travel</Link></li>
            </ul>
          </nav>
        </div>
      </header>
    </>
  );
};

export default Header;
